import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { INoteInput } from '../../../../shared/models/NotesInputModel';
import { CommonService } from '../../../../shared/providers/common.service';
import { ToastService } from '../../../../shared/providers/toast.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { INotes } from '../../../../shared/models/NotesListOutModel';
import { DataTablesResponse } from '../../../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ValidationService } from '../../../../shared/providers/validation.service';

@Component({
    selector: 'app-shared-add-notes',
    templateUrl: './shared-add-notes.component.html',
    styleUrls: ['./shared-add-notes.component.css']
})

export class SharedAddNotesComponent implements OnInit {
    @Input() modalRef: BsModalRef;
    @Input() notesInputsModel: INoteInput;
    @Output() save = new EventEmitter();
    @Output() close = new EventEmitter();
    @Input() isEditable = true as boolean;
    private _noteForm: FormGroup;
    table: DataTableDirective;
    dtOptions = {};
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    protected readonly BASE_URL: string = environment.base_url;
    public get noteForm(): FormGroup {

        return this._noteForm;
    }
    constructor(private http: HttpClient, private _CommonService: CommonService, private Toast: ToastService, public authService: AuthenticationService, public Validation: ValidationService) { }
    notesList: INotes[];
    notesId: number;
    description: string;
    user: any;
    isSubmit = false;
    isSavedAnyNote = false;

    ngOnInit() {
        this.user = this.authService.user;
        this.loadNotes();
    }

    loadNotes() {
        this._CommonService.getNotesList(this.notesInputsModel).subscribe(response => {
            this.notesList = response;
        });
    }

    convertUTCDateToLocalDateNotes(EnteredOn: Date) {
        var newDate = new Date(EnteredOn);
        var offset = newDate.getTimezoneOffset() / 60;
        var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
        return offsetTime;
  }

  onCloseModel() {
    if (this.isSavedAnyNote) {
      this.close.emit(true);
    }
    
  }

  
    onClose($event) {
      this.close.emit();
    }

    saveNote() {
        this.isSubmit = true;
        if (!this.Validation.IsinValid(this.notesInputsModel.Description)) {
            this.user = this.authService.user;
            if (this.user.Guid != undefined) {
                this.notesInputsModel.UserId = this.user.Id;
            }

            this._CommonService.SaveNote(this.notesInputsModel).subscribe(response => {

              if (response.IsSuccess) {
                this.isSavedAnyNote = true;
                  this.Toast.addToast({ title: 'Success', msg: 'Notes added Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                    this.loadNotes();
                    this.notesInputsModel.Description = '';
                    this.isSubmit = false;
                    //this.modalRef.hide();
                }
                else {
                  this.Toast.addToast({ title: 'Error Occurred', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                }
            });
        }

    }

    DeleteNote(note: INoteInput) {
        this._CommonService.DeleteNote(note).subscribe(response => {
            const foundIndex = this.notesList.findIndex(({ Id }) => Id === note.Id);
            this.notesList = this.notesList.filter((_, index) => index !== foundIndex);
        });
    }
}
